<template>
  <!-- eslint-disable max-len -->
  <div class="container">
    <br />
    <br />
    <br />
    <br />
    <div class="row">
      <div class="col-md-12 col-lg-8">
        <div class="title-box-d">
          <h1 class="title-d" style="text-align:left; font-size: 250%">Search Results</h1>
        </div>
        <br />
      </div>
      <!-- <div class="row mb-4">
        <div class="col-md-4">
          <img />
        </div>
        <div class="col-md-4">
          <img />
        </div>
        <div class="col-md-4">
          <img />
        </div>
      </div>-->
    </div>
    <br />
    <WeekListComponent />
    <br />
  </div>
</template>
<script>
import WeekListComponent from './weekListComponent.vue';

export default {
  components: {
    WeekListComponent,
  },
  computed: {},
};
</script>
<style>
</style>
